import {
    GET_OUTDOOR_SPORTS_SUMMARY_DATA,
    GET_OUTDOOR_SPORTS_DETAIL_DATA,
    GetOutdoorSportsSummaryActionType, 
    GetOutdoorSportsDetailActionType,
    GetOutdoorSportsLegendActionType,
    GET_OUTDOOR_SPORTS_LEGEND_DATA,
    OutdoorSportsSummaryData,
    OutdoorSportsDetailData,
    OutdoorSportsLegendData,
    ErrorType 
} from '../actions/outdoorSportsActions';

const initialState: OutdoorSportsState = {
    outdoorSportsDataIsFetching: false
};

export interface OutdoorSportsState {
    outdoorSportsDataIsFetching? : boolean;
    outdoorSportsSummaryData?: OutdoorSportsSummaryData;
    outdoorSportsDetailData?: OutdoorSportsDetailData;
    outdoorSportsLegendData?: OutdoorSportsLegendData;
    error?: boolean | Record<string, unknown> | unknown;
}

export type OutdoorSportsActionType = ErrorType | GetOutdoorSportsDetailActionType | GetOutdoorSportsSummaryActionType | GetOutdoorSportsLegendActionType;

export function outdoorSports(state: OutdoorSportsState = initialState, action: OutdoorSportsActionType): OutdoorSportsState
{
    switch (action.type)
    {
        case GET_OUTDOOR_SPORTS_SUMMARY_DATA.pending:
        {
            return {
                ...state,
                outdoorSportsDataIsFetching: true
            };
        }
        case GET_OUTDOOR_SPORTS_SUMMARY_DATA.fulfilled:
        {
            return {
                ...state,
                outdoorSportsSummaryData: action.payload as OutdoorSportsSummaryData,
                error: false,
                outdoorSportsDataIsFetching: false
            };
        }

        case GET_OUTDOOR_SPORTS_SUMMARY_DATA.rejected:
        {
            return {
                ...state,
                outdoorSportsSummaryData: undefined,
                error: action.payload,
                outdoorSportsDataIsFetching: false
            };
        }
        case GET_OUTDOOR_SPORTS_DETAIL_DATA.pending:
        {
            return {
                ...state,
                outdoorSportsDataIsFetching: true
            };
        }
        case GET_OUTDOOR_SPORTS_DETAIL_DATA.fulfilled:
        {
            return {
                ...state,
                outdoorSportsDetailData:  action.payload as OutdoorSportsDetailData,
                error: false,
                outdoorSportsDataIsFetching: false
            };
        }
    
        case GET_OUTDOOR_SPORTS_DETAIL_DATA.rejected:
        {
            return {
                ...state,
                outdoorSportsDetailData: undefined,
                error: action.payload,
                outdoorSportsDataIsFetching: false
            };
        }
        case GET_OUTDOOR_SPORTS_LEGEND_DATA.pending:
        {
            return {
                ...state,
                outdoorSportsDataIsFetching: true
            };
        }
        case GET_OUTDOOR_SPORTS_LEGEND_DATA.fulfilled:
        {
            return {
                ...state,
                outdoorSportsLegendData: action.payload as OutdoorSportsLegendData,
                error: false,
                outdoorSportsDataIsFetching: false
            };
        }
        
        case GET_OUTDOOR_SPORTS_LEGEND_DATA.rejected:
        {
            return {
                ...state,
                outdoorSportsLegendData: undefined,
                error: action.payload,
                outdoorSportsDataIsFetching: false
            };
        }
        default: 
        {
            return state;
        }
    }
}
